<template>
  <div class="imdiv" v-on:click="goArtistPortfolio">
    <div class="square-filler">
      <ix-router-link :to="'/animators/' + artist.portfolio_url"><transition name="fade"><img v-if="seen"
      :src="getImageUrl(artist)" :alt="artist.formatted_name" class="main" /></transition></ix-router-link>
    </div>
    <template v-if="isGif && hovered">
      <square-gif-viewer :src="mediaPath" />
    </template>
    <template v-if="hasPreviewClip && hovered">
      <square-clip-viewer :src="previewClipUrl" />
    </template>
    <grey-bar :artist="artist" :likeImageId="artist.az_animation.image_id" animation />
  </div>
</template>

<script>
//import apix from '@/api.js'
import GreyBar from '@/components/widgets/GreyBar.vue'
import SquareGifViewer from '@/components/widgets/SquareGifViewer.vue'
import SquareClipViewer from '@/components/widgets/SquareClipViewer.vue'
import ViewablePanel from '@/mixins/ViewablePanel.js'


export default {
  components: {
    GreyBar,
    SquareGifViewer,
    SquareClipViewer
  },
  mixins: [ViewablePanel],
  props: {
    artist: Object,
    pageSettings: String
  },
  data () {
    return {
      isGif: false,
      hasPreviewClip: false,
      previewClipUrl: '',
      mediaPath: '',
      hovered: false
    }
  },
  created () {
    this.setup()
  },
  mounted () {
    this.$el.addEventListener('mouseover', () => {
      this.hovered = true
    })
    this.$el.addEventListener('mouseout', () => {
      this.hovered = false
    })
  },
  methods: {
    setup: async function () {
      if(this.artist){
        if(this.artist.az_animation){
          const image = this.artist.az_animation
          const ext = this.$k.getExtension(image.swf)
          this.isGif = (ext === 'gif')
          if(this.isGif) {
            this.mediaPath = this.$k.imagebase + 'media/artist/' + this.artist.portfolio_url + '/' + image.swf
          }
          else {
            this.hasPreviewClip = this.$k.canHaveClip(image.swf)
            this.previewClipUrl = this.$k.getPreviewClipUrl(image, this.artist)
          }
        }
      }
    },
    goArtistPortfolio: function () {
      this.$ixr.push('/animators/' + this.artist.portfolio_url)
    },
  
    getImageUrl: function() {
      return this.$k.getImageCrop500(this.artist.az_animation.url)
    }
  },
  watch: {
    artist () {
      this.setup()
    },
    pageSettings () {
      this.setInView()
    }
  }
}
</script>

<style scoped>
img.main{
  position:absolute;
  top:50%;
  left:50%;
  width:100%;
  transform:translate(-50%,-50%);
  transition:all 0.3s ease;
}

.square-filler{
  position:relative;
  overflow:hidden;
  width:100%;
  padding-bottom:100%;
  height:0;
}

.imdiv:hover img.main{
  width:107%!important;
}

</style>
